export const formatDocumento = value => {
  if (!value) return '-';
  const digits = String(value).replace(/\D/g, '');
  if (!digits) return '-';

  if (digits.length <= 11) {
    return digits
      .slice(0, 11)
      .replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2}).*$/, (_, a, b, c, d) => {
        let out = a;
        if (b) out += '.' + b;
        if (c) out += '.' + c;
        if (d) out += '-' + d;
        return out;
      });
  }
  return digits
    .slice(0, 14)
    .replace(
      /^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2}).*$/,
      (_, a, b, c, d, e) => {
        let out = a;
        if (b) out += '.' + b;
        if (c) out += '.' + c;
        if (d) out += '/' + d;
        if (e) out += '-' + e;
        return out;
      }
    );
};
